import { render } from "./videoForm.vue?vue&type=template&id=3f6eb8b7&scoped=true&ts=true"
import script from "./videoForm.vue?vue&type=script&lang=ts"
export * from "./videoForm.vue?vue&type=script&lang=ts"

import "./videoForm.vue?vue&type=style&index=0&id=3f6eb8b7&lang=scss&scoped=true"

import exportComponent from "D:\\work\\CP_new_work\\saas-h5-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f6eb8b7"]])

export default __exports__